import { render, staticRenderFns } from "./InputOriginSampleInfo.vue?vue&type=template&id=c04279e6&scoped=true&"
import script from "./InputOriginSampleInfo.vue?vue&type=script&lang=js&"
export * from "./InputOriginSampleInfo.vue?vue&type=script&lang=js&"
import style0 from "./InputOriginSampleInfo.vue?vue&type=style&index=0&id=c04279e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04279e6",
  null
  
)

export default component.exports